import React, {useState} from 'react';
import PropTypes from 'prop-types';


import * as dataUtils from '../../../../../utils/dataUtils';
import * as inputConstants from '../inputConstants';
import * as passwordInputConstants from './passwordInputConstants';

import {textInputConstants} from '../TextInput';

import Input from '../Input';
import Checkbox from '../../Checkbox/Checkbox';

import styles from './PasswordInput.scss';


function PasswordInput(props) {

    const [doShowPassword, setDoShowPassword] = useState(false);

    return (
        <div className={styles.inputPassword}>
            <Input
                {...props}
                maxLength={props.maxLength}
                type={doShowPassword ? textInputConstants.TYPE : passwordInputConstants.TYPE}
            />

            <div className={styles.showPassword}>
                <Checkbox
                    isChecked={doShowPassword}
                    onChange={isChecked => setDoShowPassword(isChecked)}
                />
                <span>
                    &nbsp;
                </span>
            </div>

        </div>
    );
}


PasswordInput.propTypes = {
    ...dataUtils.removeKey(Input.propTypes, 'type'),
    autoComplete: PropTypes.oneOf([
        inputConstants.AUTOCOMPLETE_PASSWORD_CURRENT,
        inputConstants.AUTOCOMPLETE_PASSWORD_NEW
    ]),
    maxLength: PropTypes.number
};

PasswordInput.defaultProps = {
    ...Input.defaultProps,
    autoComplete: inputConstants.AUTOCOMPLETE_PASSWORD_CURRENT,
    maxLength: passwordInputConstants.MAX_LENGTH
};


export default PasswordInput;
